import React from "react";
import { FileMinus } from "lucide-react";
import { useRemoveUserSite } from "../hooks";
import { Loading } from "../../../components";

interface IRemoveUserSiteProps {
  userSiteId: number;
  refetch: any;
}

export const RemoveUserSite: React.FC<IRemoveUserSiteProps> = ({
  userSiteId,
  refetch,
}) => {
  const { loading, submit } = useRemoveUserSite({
    id: userSiteId,
    onCompleted: () => {
      refetch();
    },
  });

  return (
    <div className="flex justify-center align-items cursor-pointer">
      {loading ? (
        <Loading />
      ) : (
        <>
          <FileMinus className="mr-2" size={16} />
          <span onClick={submit}>Supprimer</span>
        </>
      )}
    </div>
  );
};
